import React from "react";
import {
  logout,
  userprofile,
  UpdateProfile,
  deleteAccount,
  CheckUser,
  getCountry,
} from "../../Model/Users"; //Include Home
import { Link, NavLink } from "react-router-dom";

import { isMobile } from "react-device-detect";
import { VirsionCheck, branchIO } from "../../Helpers/Common"; //Include Home
import {
  SVGIcons,
  ImgIcons,
  withRouter,
  Appsflyer,
} from "../../Helpers/Common";
import { motion } from "framer-motion";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import Search from "../search/Search";
import Notification from "../Notification/Notification";
import BarLoader from "react-spinners/BarLoader";
import $ from "jquery";

var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));
class Profilemenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      showconfirm: false,
      showDelete: false,
      userData: false,
      childlockbtnConfrim: false,
      userchecked: false,
      SearchClick: false,
      showUserStatusPop: false,
      showMessagePop: "",
      isLive: true,
      goldenDIcon: "",
      silverDIcon: "",
    };
  }

  componentDidMount() {
    VirsionCheck().then((vcheckres) => {
      this.setState({
        isLive: JSON.parse(vcheckres.data).data.is_live_tv,
        goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
        silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
      });
    });
    if (this.props.profile) {
      this.setState({
        VirsionCheckData: this.props.versioncheck,
        VirsionCheckDataloaded: true,
        userData: this.props.profile,
        userchecked: localStorage.getItem("is_child_local_storage"),
      });
    } else {
      //Get Virsion Check Data
      VirsionCheck().then((vcheckres) => {
        this.setState({
          goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
          silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
        });
        let data = {
          seesionID: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        }
        userprofile(data).then((userDatares) => {
          if (userDatares.data.message == "session_expired") {
            //Redirect To login page.
            //this.props.navigate("/signup");
            this.setState({
              VirsionCheckData: vcheckres,
              VirsionCheckDataloaded: true,
            });
          } else {
            var userDatares = JSON.parse(userDatares.data.message);
            if (userDatares.errorcode == "1008") {
              this.setState({
                VirsionCheckData: vcheckres,
                VirsionCheckDataloaded: true,
              });
            } else {
              this.setState({
                VirsionCheckData: vcheckres,
                VirsionCheckDataloaded: true,
                userData: userDatares.user_data,
                userchecked: localStorage.getItem("is_child_local_storage"),
              });
            }
          }
        });
      });
    }
  }
  /*-----Logout Confirmation popup*/
  logoutconfirm() {
    this.setState({
      showconfirm: true,
    });
  }

  Deleteconfirm() {
    this.setState({
      showDelete: true,
    });
  }

  Childlock() {
    this.setState({
      childlockbtnConfrim: true,
    });
  }
  /*-------Logout-------*/
  Logout() {
    //Call logout Api
    let data = {
      seesionID: localStorage.getItem("session_id"),
      msisdn: localStorage.getItem("msisdn")
    }

    Appsflyer("logout", {});
    logout(data).then((ResofLogout) => {
      // branchIO("Sign Out", { "user":ResofLogout });
      localStorage.clear();
      window.localStorage.clear()
      this.props.navigate("/createaccount");
    });
  }

  delete() {
    //Call logout Api
    CheckUser().then((res) => {
      let data = {
        user_id: res.user_data.ID,
        session_id: res.session_id,
        action: 2,
      };

      if (this.state.userData.is_subscribed == true) {
        this.setState({
          showUserStatusPop: true,
          showDelete: false,
          showMessagePop: "You have an active membership with us. Once your membership ends or expires, you will be able to delete your account.",
        });
      } else {
        deleteAccount(data).then((res) => {
          // branchIO("Delete my Account", {"user": data });
          this.setState({
            showUserStatusPop: false,
            showDelete: true,
          });
          this.props.navigate("/createaccount");
        });
      }
    });
  }

  cancel() {
    //Call logout Api
    this.setState({
      showconfirm: false,
      childlockbtnConfrim: false,
      showDelete: false,
      showUserStatusPop: false,
    });
  }

  childlockOn() {
    if (localStorage.getItem("is_child_local_storage") == "false") {
      var status = "true";
    } else {
      var status = "false";
    }
    var PostData = {
      is_child: status,
      seesionID: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    };

    UpdateProfile(PostData).then((resp) => {
      var Respup = JSON.parse(resp.data.message);
      if (Respup.success == true) {
        localStorage.setItem("is_child_local_storage", status)
        if (this.state.userchecked == false) {
          this.setState({
            childlockbtnConfrim: false,
            userchecked: true,
          });
        } else {
          this.setState({
            childlockbtnConfrim: false,
            userchecked: false,
          });
        }
      }
    });
  }

  search() {
    this.setState({
      SearchClick: true,
    });
  }

  //
  SearchClose() {
    this.setState({
      SearchClick: false,
    });
  }

  Notification() {
    this.setState({
      NotificationClick: true,
    });
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }
    if (this.state.SearchClick === true) {
      return (
        <Search
          functions={this}
          closefrom="true"
          goldenIcon={this.state.goldenDIcon}
          silverIcon={this.state.silverDIcon}
        />
      );
    }
    if (this.state.NotificationClick === true) {
      return <Notification functions={this} />;
    }
    var Logoutconfirm;
    var Deleteconfirm;
    var ChidllockStatus;

    if (this.state.showconfirm == true) {
      var Logoutconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>Are you sure you want to log out?</h6>
            </div>

            <button
              type="submit"
              id="sendEnquiryBtn"
              className="btn-white"
              onClick={() => {
                this.cancel();
              }}
            >
              Cancel
            </button>
            <p
              className="temp52-modal-close"
              onClick={() => {
                this.Logout();
              }}
            >
              Log Out
            </p>
          </div>
        </div>
      );
    }

    if (this.state.showDelete == true) {
      var Deleteconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>
                Are you sure you want to delete your account? Kindly note this
                action can not be undone.
              </h6>
            </div>
            <p
              type="submit"
              id="sendEnquiryBtn"
              className="temp52-modal-close"
              onClick={() => {
                this.cancel();
              }}
            >
              Cancel
            </p>
            <button
              className="btn-white"
              onClick={() => {
                this.delete();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      );
    }

    if (this.state.showUserStatusPop == true) {
      var Deleteconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>{this.state.showMessagePop}</h6>
            </div>
            <button
              className="btn-white"
              onClick={() => {
                this.cancel();
              }}
            >
              OK
            </button>
          </div>
        </div>
      );
    }

    if (this.state.childlockbtnConfrim == true) {
      var ChildlockbtnConfrim = (
        <div className="logOutpopup">
          <div className="temp78-modal-body">
            <div className="temp78-awesome">
              <img src={SVGIcon["child-lock-alert.png"]} />
              {this.state.userchecked ? (
                <h6>
                  You will be able to see our entire vast catalogue again,
                  including ones which are age restricted with Child Lock!
                </h6>
              ) : (
                <h6>
                  Based on our age ratings, some titles may no longer be visible
                  for your account, You may not be able to experience our entire
                  vast catalogue!
                </h6>
              )}

              <h2>
                Are you sure you want to{" "}
                {localStorage.getItem("is_child_local_storage") == "true" ? "disable" : "enable"} Child Lock?
              </h2>
            </div>
            <p
              className="temp78-modal-close"
              onClick={() => {
                this.cancel();
              }}
            >
              No
            </p>
            <button
              type="submit"
              id="sendEnquiryBtn"
              className="btn-white"
              onClick={() => {
                this.childlockOn();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      );
    }
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      //var MetaData = JSON.parse(this.state.VirsionCheckData.data).data.page.signup;
      if (localStorage.getItem("is_child_local_storage") == "true") {
        ChidllockStatus = <div className="switch-activ">Active</div>;
      } else {
        ChidllockStatus = <div className="switch-Inactiv">Inactive</div>;
      }

      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <main>
                <div className="temp46 dD-block">
                  <div className="temp46-inn" id="desktop-profile-id">
                    <Link to="/">
                      <div className="temp46-logo">
                        <img
                          src={ImageData["docu-bay-white.png"]}
                          alt="Logo"
                          className="logo"
                        />
                      </div>
                    </Link>
                    <NavLink
                      to="/manage-membership"
                      className={({ isActive }) =>
                        isActive ? "temp46-area isActiveRoute" : ""
                      }
                    >
                      <div className="img-area">
                        <img
                          src={SVGIcon["manage-membership.svg"]}
                          alt="DocuBay"
                        />
                      </div>
                      My Membership
                    </NavLink>

                    {this.state.userData ? (
                      <div className="temp46-area">
                        <div className="img-area">
                          <img src={SVGIcon["child-lock.svg"]} alt="DocuBay" />
                        </div>
                        Child Lock
                        {ChidllockStatus}
                        <label className="switch childLock-modal-toggle">
                          <div
                            className="switch-text"
                            onClick={() => {
                              this.Childlock();
                            }}
                          >
                            {" "}
                            <span>On</span> <span>Off</span>{" "}
                          </div>
                          {/* <input type="checkbox" check> */}
                          <span
                            className={localStorage.getItem("is_child_local_storage") == "true" ? "slider round" : "slider"}
                            onClick={() => {
                              this.Childlock();
                            }}
                          />
                        </label>
                      </div>
                    ) : null}

                    <NavLink
                      to="/about-us"
                      className={({ isActive }) =>
                        isActive ? "temp46-area isActiveRoute" : "temp46-area"
                      }
                    >
                      <div className="img-area">
                        <img
                          src={SVGIcon["about.png"]}
                          alt="DocuBay"
                          className="abv"
                        />
                      </div>
                      About
                    </NavLink>
                    {!this.state.userData ? (
                      <NavLink
                        to="/createaccount"
                        className={({ isActive }) =>
                          isActive ? "temp46-area isActiveRoute" : "temp46-area"
                        }
                      >
                        <div className="img-area">
                          <img
                            src={SVGIcon["manage-profile.svg"]}
                            alt="DocuBay"
                          />
                        </div>
                        Create Account
                      </NavLink>
                    ) : null}
                    <NavLink
                      to="/privacy"
                      className={({ isActive }) =>
                        isActive ? "temp46-area isActiveRoute" : "temp46-area"
                      }
                    >
                      <div className="img-area">
                        <img
                          src={SVGIcon["privacy-policy.svg"]}
                          alt="DocuBay"
                        />
                      </div>
                      Privacy Policy
                    </NavLink>
                    <NavLink
                      to="/terms"
                      className={({ isActive }) =>
                        isActive ? "temp46-area isActiveRoute" : "temp46-area"
                      }
                    >
                      <div className="img-area">
                        <img src={SVGIcon["terms-of-use.svg"]} alt="DocuBay" />
                      </div>
                      Terms Of Use
                    </NavLink>
                    {this.state.userData ? (
                      <div className="temp46-area">
                        <a
                          className="temp52-modal-toggle"
                          onClick={() => {
                            this.logoutconfirm();
                          }}
                        >
                          <div className="img-area">
                            <img src={SVGIcon["log-out.svg"]} alt="DocuBay" />
                          </div>
                          Log Out
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </main>
              {Logoutconfirm}
              {Deleteconfirm}
              {ChildlockbtnConfrim}
            </>
            {/* {isMobile ? <Mobilemenu active="5" /> : <Profilemenu userdata={this.state.userData} />} */}
            <Mobilemenu active="5" isLive={this.state.isLive} />
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Profilemenu);
